import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IHeaderInput {
  disabled: boolean;
  placeholder: string;
}

interface IInputState {
  startAnimation: boolean;
}

interface IState {
  search: string;
  headerInput: Partial<IHeaderInput & IInputState>;
}

const initialState: IState = {
  search: '',
  headerInput: {
    disabled: true,
    placeholder: '',
    startAnimation: false,
  },
};

export const globalSearchSlice = createSlice({
  name: 'globalSearch',
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    toggleInputFadeAnimation: (state) => {
      state.headerInput.startAnimation = !state.headerInput.startAnimation;
    },
    setHeaderInputProps: (state, action: PayloadAction<Partial<IHeaderInput & IInputState>>) => {
      state.headerInput = {
        ...state.headerInput,
        ...action.payload,
      };
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
  },
});

export const { setSearch, setHeaderInputProps, clear, toggleInputFadeAnimation } = globalSearchSlice.actions;
export default globalSearchSlice.reducer;
